'use client';

import { type ReactNode } from 'react';
import { CircularProgress, Box } from '@mui/material';

interface Props {
  children?: ReactNode;
}

/**
 *
 * @returns Activity indicator that takes the whole parent size and
 * shows a circular progress icon in the center.
 */
export function LoadingFallback({ children }: Props) {
  return (
    <Box
      flexGrow={1}
      sx={{
        gap: 2,
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        height: '100%',
        width: '100%',
        position: 'relative',
        overflowY: 'auto',
      }}
    >
      <CircularProgress role="progressbar" aria-label="Loading" />
      <Box component="p">{children}</Box>
    </Box>
  );
}
